<template>
    <div class="input-container" :class="{enableCopy: data.enableCopy}">
        <div class="input-wrapper">
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-if="data.formType === 'select'">
                <LanogaSelect
                        v-model="val"
                        :title="data.tooltipText"
                        :readonly="data.formReadOnly"
                        :required="data.formRequired && !data.formReadOnly"
                        :showPopOver="data.showPopOver"
                        :options="data.selectOptions"
                        :name="data.name"
                        :external-option-list="data.selectOptions.externalOptionList"
                        :additional-api-callback-params="data.selectOptions.additionalApiCallbackParams"
                        @input="exportData"
                        @cleared="clearSelect">
                </LanogaSelect>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <div v-else-if="data.formType === 'address'">
                <AddressInput
                        :required="data.formRequired"
                        :readOnly="data.formReadOnly"
                        :data="data"
                        v-model="val"
                        @input="exportData">
                </AddressInput>
            </div>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType === 'textarea'">
                <b-form-textarea
                        v-bind:required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="val"
                        :placeholder="data.label"
                        rows="3"
                        max-rows="6"
                        @input="exportData"/>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType === 'textarea_resizable'">
                <b-form-textarea
                        v-bind:required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="val"
                        :placeholder="data.label"
                        @input="exportData"/>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                            v-else-if="data.formType === 'xlsFileInput'">
                <b-overlay :show="busy" rounded="lg" opacity="0.6">

                <template #overlay>
                    <div class="d-flex align-items-center">
                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                        <b-spinner type="grow" variant="dark"></b-spinner>
                        <b-spinner small type="grow" variant="secondary"></b-spinner>
                    </div>
                </template>

                <div @click="clickInput">
                    <b-form-file
                        ref="fileInput"
                        v-model="val"
                        :state="isValidFile === null ? null : isValidFile"
                        :placeholder="data.label"
                        :drop-placeholder="data.label"
                        accept=".xlsx"
                        browse-text="Tallózás"
                        :size="data.fileSize"
                        :required="data.formRequired"
                        :readonly="data.formReadOnly"
                        :multiple="data.multipleFile"
                        @input="exportData"
                        @change="validateFile">
                    </b-form-file>
                </div>

                </b-overlay>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ 'Feltöltés...' }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'emailBody'">
                <label class="header-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
                <quill-editor
                        v-bind:required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="val"
                        :options="quillOptions"
                        @input="exportData"
                        @blur="onEditorBlur($event)"
                        @focus="onEditorFocus($event)"
                        @ready="onEditorReady($event)">
                </quill-editor>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'socialInsuranceNumber' || data.name === 'pSocialInsuranceNumber' || data.name === 'patientSocialInsuranceNumber'||data.name === 'patient.socialInsuranceNumber'">
                <b-form-input
                        :type="data.formType"
                        :value="val"
                        v-mask="'###-###-###'"
                        size="sm"
                        :placeholder="data.label"
                        @input="exportData"
                        v-bind:readonly="data.formReadOnly"
                        v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'healthcareId'">
                <b-form-input
                        :type="data.formType"
                        :value="val"
                        :maxLength="4"
                        size="sm"
                        :placeholder="data.label"
                        @input="exportData"
                        v-bind:readonly="data.formReadOnly"
                        v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'centerCode'">
                <b-form-input
                        :type="data.formType"
                        :value="val"
                        :maxLength="15"
                        :placeholder="data.label"
                        @input="exportData"
                        v-bind:readonly="data.formReadOnly"
                        v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'ccCode'">
                <b-form-input
                        type="text"
                        :value="val"
                        :maxLength="2"
                        :placeholder="data.label"
                        @input="exportData"
                        :formatter="formatCodeCC"
                        v-bind:readonly="data.formReadOnly"
                        v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'kaszCode'">
                <b-form-input
                        :type="data.formType"
                        :value="val"
                        :maxLength="25"
                        :placeholder="data.label"
                        @input="exportData"
                        v-bind:readonly="data.formReadOnly"
                        v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'kaszKod'">
                <b-form-input
                        :type="data.formType"
                        :value="val"
                        :maxLength="15"
                        :placeholder="data.label"
                        @input="exportData"
                        v-bind:readonly="data.formReadOnly"
                        v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.name === 'deviceIdInput'">
                <b-form-input
                        :type="data.formType"
                        :value="val"
                        :maxLength="data.maxLength"
                        :placeholder="data.label"
                        @input="exportData"
                        :readonly="data.formReadOnly"
                        :required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType === 'tel'">
                <vue-tel-input
                        v-bind:required="data.formRequired"
                        :readonly="data.formReadOnly"
                        v-model="val"
                        v-bind="telInputOptions"
                        aria-placeholder=" "
                        @input="exportData">
                </vue-tel-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='date'">
                <date-picker :value="formatDate"
                             @input="exportData"
                             :config="datePickerOptions"
                             v-bind:readonly="data.formReadOnly"
                             v-bind:required="data.formRequired">
                </date-picker>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>
            <div v-else-if="data.formType==='hour'" style="border: 1px #ced4da solid; border-radius: 5px;">
                <input type="time"
                       v-bind:readonly="data.formReadOnly"
                       v-bind:required="data.formRequired"
                       id="hour"
                       @input="exportData(val)"
                       v-model="val"/>
                <label :class="{'required': data.formRequired}" for="hour" >
                    {{ data.label }}
                </label>
            </div>
            <div v-else-if="data.formType==='hourWithSeconds'" style="border: 1px #ced4da solid; border-radius: 5px;">
              <input type="time"
                     v-bind:readonly="data.formReadOnly"
                     v-bind:required="data.formRequired"
                     id="hourWithSeconds"
                     @input="exportData(val)"
                     v-model="val"/>
              <label :class="{'required': data.formRequired}" for="hour" >
                {{ data.label }}
              </label>
            </div>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='dateMonth'">
                <date-picker :value="formatDate"
                             @input="exportData"
                             :config="dateMonthPickerOptions"
                             v-bind:readonly="data.formReadOnly"
                             v-bind:required="data.formRequired">
                </date-picker>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='dateTime'">
                <date-picker :value="formatDate"
                             :title="data.tooltipText"
                             @input="exportData"
                             :config="dateTimePickerOptions"
                             v-bind:readonly="data.formReadOnly"
                             v-bind:required="data.formRequired">
                </date-picker>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='time'">
                <input :value=formatDateTime
                       :type="data.formType"
                       size="sm"
                       class="form-control form-control-sm"
                       :placeholder="data.label"
                       @input="exportData"
                       v-bind:readonly="data.formReadOnly"
                       v-bind:required="data.formRequired">
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='checkboxes'">
                <Checkboxes :value="val"
                            :name="data.name"
                            :label="data.label"
                            :options="data.checkboxesOptions"
                            :additional-api-callback-params="data.checkboxesOptions.additionalApiCallbackParams"
                            @input="exportData">
                </Checkboxes>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='checkbox'">
                <small class="form-text text-muted smooth-label-description" v-html="data.description"
                       v-if="data.description"/>
                <b-form-checkbox
                        v-model="val"
                        :name="data.name"
                        value="true"
                        :disabled="data.formReadOnly"
                        unchecked-value="false"
                        @input="exportData">
                    {{data.label}}
                </b-form-checkbox>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='customRadioButton'">
                <CustomRadioButtonGroup :label="data.label"
                                        :label-cols="true"
                                        :content-cols="true"
                                        v-model="val"
                                        @input="exportData">
                </CustomRadioButtonGroup>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}"
                          v-else-if="data.formType==='number'">
                <small class="form-text text-muted smooth-label-description" v-html="data.description"
                       v-if="data.description"/>
                <b-form-input :type="data.formType"
                              :value="val"
                              size="sm"
                              :placeholder="data.label"
                              :step="data.numberStep ? data.numberStep : 1"
                              @input="exportData"
                              :min="data.numberMin"
                              v-bind:readonly="data.formReadOnly"
                              v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

            <b-form-group v-else-if="data.formType==='dynamicListInput'">
                <DynamicListInput v-model="val" :config="data.dynamicListInputConfig" @input="exportData"/>
            </b-form-group>

            <!-- @deprecated -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectBNO'">
                <SelectBNODialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <!-- Single Selection BNO Dialog -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectBNOSingle'">
                <SelectBNOSingleDialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <!-- Single Selection BNO Dialog -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectMedicationSingle'">
                <SelectMedicationSingleDialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <!-- Multiple Selection Medication Dialog -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectMedicationMulti'">
                <SelectMedicationMultiDialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectTreatmentsMulti'">
                <SelectTreatmentsMultiDialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <!-- Multiple Selection BNO Dialog -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectBNOMulti'">
                <SelectBNOMultiDialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <!-- Multiple Selection Packages Dialog -->
            <b-form-group :class="{filled: checkFilled(value)}" v-else-if="data.formType==='selectPackMulti'">
                <SelectPackagesMultiDialog :value="val" :label="data.label" :options="data.selectOptions" :required="data.formRequired" @input="exportData"/>
            </b-form-group>

            <b-form-group :class="{filled: checkFilled(value), 'd-none': !data.formVisible}"
                          v-else>
                <small class="form-text text-muted smooth-label-description" v-html="data.description"
                       v-if="data.description"/>
                <b-form-input :type="data.formType"
                              :value="val"
                              size="sm"
                              :maxLength="data.maxLength"
                              :placeholder="data.label"
                              @input="exportData"
                              v-bind:readonly="data.formReadOnly"
                              v-bind:required="data.formRequired">
                </b-form-input>
                <label class="smooth-label" :class="{'required': data.formRequired}" :for="data.name">
                    {{ data.label }}
                </label>
            </b-form-group>

        </div>
        <div class="icon-wrapper" v-if="data.enableCopy" @click="copyToClipboard" ref="copyWrapper">
            <span><i class="far fa-copy"/></span>
        </div>
    </div>
</template>

<!--Masking: https://vuejs-tips.github.io/vue-the-mask/ -->
<!--QUILL EDITOR DOC: https://github.com/surmon-china/vue-quill-editor -->

<script>
    import AddressInput from "./AddressInput";
    import LanogaSelect from "./LanogaSelect";
    import Checkboxes from "./Checkboxes";
    import DynamicListInput from "./DynamicListInput"
    import SelectBNODialog from "./SelectBNODialog";
    import SelectBNOSingleDialog from "@/components/SelectBNOSingleDialog";
    import SelectBNOMultiDialog from "@/components/SelectBNOMultiDialog";
    import SelectMedicationMultiDialog from "@/components/SelectMedicationMultiDialog";
    import SelectMedicationSingleDialog from "@/components/SelectMedicationSingleDialog"
    import SelectPackagesMultiDialog from "@/components/SelectPackagesMultiDialog"
    import SelectTreatmentsMultiDialog from "./SelectTreatmentsMultiDialog.vue";
    import CustomRadioButtonGroup from '@/components/CustomRadioButtonGroup.vue';

    export default {
        name: "FormInputFormat",
        components: {
            SelectBNOMultiDialog,
            SelectBNOSingleDialog,
            SelectBNODialog,
            SelectMedicationMultiDialog,
            SelectMedicationSingleDialog,
            Checkboxes,
            LanogaSelect,
            AddressInput,
            DynamicListInput,
            SelectPackagesMultiDialog,
            SelectTreatmentsMultiDialog,
            CustomRadioButtonGroup,
        },
        data() {
            return {
                busy: false,
                isValidFile: null,
                quillOptions: {
                    placeholder: 'Kezdjen el gépelni!'
                },
                telInputOptions: {
                    defaultCountry: "HU",
                    disabledFetchingCountry: false,
                    disabled: false,
                    disabledFormatting: false,
                    placeholder: "Telefonszám",
                    required: false,
                    enabledCountryCode: false,
                    enabledFlags: true,
                    preferredCountries: ["HU"],
                    onlyCountries: [],
                    ignoredCountries: [],
                    autocomplete: "on",
                    name: "telephone",
                    maxLen: 25,
                    wrapperClasses: "",
                    inputClasses: "",
                    mode: "international",
                    dropdownOptions: {
                        disabledDialCode: false
                    },
                    inputOptions: {
                        showDialCode: false
                    }
                },
                val: this.value,
                datePickerOptions: {
                    format: 'YYYY.MM.DD.',
                    useCurrent: false,
                    collapse: false,
                    locale: this.$moment.locale('hu'),
                    showTodayButton: true,
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
                dateMonthPickerOptions: {
                    format: 'YYYY.MM.',
                    useCurrent: false,
                    locale: this.$moment.locale('hu'),
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
                dateTimePickerOptions: {
                    format: 'YYYY.MM.DD. HH:mm',
                    useCurrent: false,
                    locale: this.$moment.locale('hu'),
                    icons: {
                        time: 'far fa-clock',
                        date: 'far fa-calendar',
                        up: 'fas fa-arrow-up',
                        down: 'fas fa-arrow-down',
                        previous: 'fas fa-chevron-left',
                        next: 'fas fa-chevron-right',
                        today: 'fas fa-calendar-check',
                        clear: 'far fa-trash-alt',
                        close: 'far fa-times-circle'
                    }
                },
            }
        },
        props: {
            data: {type: Object},
            value: {type: [String, Number, Object, Array, Boolean, File, Date]}
        },
        computed: {
            formatDate() {
                if (this.val) {
                    if (this.data.formType === 'date') {
                        return this.$moment(this.val).format('YYYY-MM-DD');
                    } else if (this.data.formType === 'dateTime') {
                        return this.$moment(this.val).format('YYYY-MM-DD HH:mm:ss');
                    } else if (this.data.formType === 'dateMonth') {
                        return this.$moment(this.val).format('YYYY-MM');
                    } else {
                        return this.val;
                    }
                } else {
                    return this.val;
                }

            },
            formatDateTime() {
                if (this.val) {
                    if (this.data.formType == 'time') {
                        return this.$moment(this.val).format('HH:mm').toString();
                    }else if (this.data.formType === 'hourWithSeconds') {
                      return this.$moment(this.val, 'HH:mm').format('HH:mm')
                    }
                    else {
                        return this.val;
                    }
                } else {
                    return this.val;
                }
            }
        },
        methods: {
            formatCodeCC(value){
                return String(value).replace(/\D/g, '');
            },
            clickInput(){
                this.resetFileData()
            },
            resetFileData() {
                this.$refs.fileInput.reset();
            },
            validateFile(event) {
                const files = event.target.files;
                
                let isValid = true;
                this.busy = true;

                if (!files.length) {
                    this.isValidFile = null;
                    this.busy = false;
                    return;
                }

                setTimeout(() => {
                    for (let i = 0; i < files.length; i++) {
                    const file = files[i];

                        if (!(file.name.endsWith('.xlsx'))) {
                            isValid = false;
                            break;
                        }
                    }

                    this.isValidFile = isValid;

                    if (!this.isValidFile) {
                        this.$toast.error({
                            title: 'Figyelem!',
                            message: 'Kérem a feltöltendő fájlt .xlsx formátumba töltse fel!'
                        });
                    }

                    this.busy = false;
                }, 1500); 
            },
            clearSelect() {
                this.$emit('cleared')
            },
            checkFilled(val) {
                return val !== null
                    && val !== undefined
                    && val !== ''
            },
            exportData(val) {
                if (this.data.formType === 'date') {
                    this.$emit('input', val ? this.$moment(val).format() : undefined)
                } else if (this.data.formType === 'dateTime') {
                    this.$emit('input', val ? this.$moment(val).format() : undefined)
                } else if (this.data.formType === 'hourWithSeconds') {
                  this.$emit('input', val ? this.$moment(val, 'HH:mm').format('HH:mm:ss') : undefined)
                } else if (this.data.formType === 'checkbox') {
                    let temp = val === 'true' || val === true;
                    this.$emit('input', temp)
                } else {
                    this.$emit('input', val)
                }
            },
            copyToClipboard() {
                var textArea = document.createElement("textarea");
                textArea.style.position="fixed";  //avoid scrolling to bottom

                if(this.data.formType === 'tel') {
                    textArea.value = this.value.replace(/[ +-]/g, "");
                }
                else if (this.data.label === "TAJ") {
                    textArea.value = this.value.replace(/[ -]/g, "");
                }
                else {
                    textArea.value = this.value;
                }

                this.$refs['copyWrapper'].appendChild(textArea);
                textArea.focus();
                textArea.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    //console.log('Fallback: Copying text command was ' + msg + ': ' + this.value);
                } catch (err) {
                    //console.error('Fallback: Oops, unable to copy', err);
                }

                this.$refs['copyWrapper'].removeChild(textArea);
            }
        },
        watch: {
            value: {
                deep: true,
                immediate: true,
                handler: function (val) {
                    this.val = val;
                }
            }
        },
    }
</script>

<style scoped>

    .input-container {
        display: flex;
    }

    .icon-wrapper {
        height: 38px !important;
        padding: 0.25rem 0.5rem;
        font-size: 1rem;
        line-height: 1.6;
        border-top: 1px solid #ced4da;
        border-right: 1px solid #ced4da;
        border-bottom: 1px solid #ced4da;
        border-top-right-radius: 0.2rem;
        border-bottom-right-radius: 0.2rem;
        cursor: pointer;
    }

    .input-wrapper {
        flex: 1;
    }

    .input-container.enableCopy input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .form-group {
        position: relative;
    }

    .smooth-label-description {
        display: none;
        position: absolute;
        bottom: 100%;
        width: 100%;
        background: #fff;
        border: 1px solid lightgray;
        padding: 5px;
    }

    .form-group:hover .smooth-label-description {
        display: block;
    }

    .form-group >>> .status-color {
        width: 20px;
        height: 12px;
        display: inline-block;
        border-radius: 25px;
        border: 1px solid lightgray;
        margin-right: 5px;
    }

    .form-group >>> .status-not-come {
        background-color: var(--status-not-come) !important;
    }

    .form-group >>> .status-arrived {
        background-color: var(--status-arrived) !important;
    }

    .form-group >>> .status-special {
        background-color: var(--status-special) !important;
    }

    .form-group >>> .status-reservation {
        background-color: var(--status-reservation) !important;
    }

    .form-group >>> .status-now-doctor {
        background-color: var(--status-now-doctor)!important;
    }

    .form-group >>> .status-treatment-finished {
        background-color: var(--status-treatment-finished) !important;
    }

    .form-group >>> .status-notified-by-phone {
        background-color: var(--status-notified-by-phone) !important;
    }

    .form-group >>> .status-not-reached-by-phone {
        background-color: var(--status-not-reached-by-phone) !important;
    }

    .form-group >>> .status-partner {
        background-color: var(--status-partner) !important;
    }

    .form-group >>> .status-canceled {
        background-color: var(--status-canceled) !important;
    }

    .form-group >>> .status-doctor {
        background-color: var(--status-doctor) !important;
        opacity: 0.3;
    }

    .form-group >>> .status-api-create {
        background-color: var(--status-api-create) !important;
    }

    .form-group >>> .status-approved {
        background-color: var(--status-approved) !important;
    }

    .form-group >>> .status-rejected {
        background-color: var(--status-rejected) !important;
    }

    .form-group >>> .status-disband {
        background-color: var(--status-disband) !important;
    }

    .form-group >>> .status-canceled-by-doctor {
        background-color: var(--status-canceled-by-doctor) !important;
    }

    .form-group >>> .status-b2c-package {
        background-color: var(--status-b2c-package) !important;
    }

    .form-group >>> .status-b2b-package {
        background-color: var(--status-b2b-package) !important;
    }

    .form-group >>> .status-email-sent {
        background-color: var(--status-email-sent) !important;
    }

    .form-group >>> .status-in-progress {
        background-color: var(--status-in-progress) !important;
    }

    .form-group >>> .status-ready-for-treatment {
        background-color: var(--status-ready-for-treatment) !important;
    }
    .form-group >>> .status-failed-treatment {
        background-color: var(--status-failed-treatment) !important;
    }
    .form-group >>> .status-treatment-finished-with-referral {
        background-color: var(--status-treatment-finished-with-referral) !important;
    }
</style>
